import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekButton, PeekDialog, PeekDialogActions, PeekDialogContent } from "@piiqtechnologies/ui-components";
import { useError, useLoader, useNotification, useCreateProspect } from "@piiqtechnologies/ui-lib";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { CreateProspectFormInitialValues, CreateProspectFormValidationSchema, getCreateProspectFormFields, } from "./ProspectFormConfig";
export const CreateProspectDialog = ({ open, onClose, communityId }) => {
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setNotification } = useNotification();
    const [createProspect, prospectCreated, createProspectInProgress, createProspectError] = useCreateProspect();
    useEffect(() => {
        setLoader(createProspectInProgress);
        return () => setLoader(false);
    }, [createProspectInProgress]);
    useEffect(() => {
        if (createProspectError) {
            setError(createProspectError === null || createProspectError === void 0 ? void 0 : createProspectError.message);
        }
    }, [createProspectError]);
    useEffect(() => {
        if (prospectCreated) {
            setNotification(intl.formatMessage(messages.createProspectSuccess));
            onClose();
        }
    }, [prospectCreated]);
    const onCreateProspect = (values) => {
        createProspect(Object.assign(Object.assign({}, values), { communityId, origin: "dashboard" }));
    };
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "xs", fullWidth: true, hasCloseIcon: true, title: intl.formatMessage(messages.createProspectTitle), open: open, onClose: onClose },
        React.createElement(Formik, { initialValues: CreateProspectFormInitialValues, validationSchema: CreateProspectFormValidationSchema, onSubmit: onCreateProspect }, ({ handleSubmit }) => (React.createElement(Form, null,
            React.createElement(PeekDialogContent, null,
                React.createElement(MultiColumnFormFields, { fields: getCreateProspectFormFields() })),
            React.createElement(PeekDialogActions, null,
                React.createElement(PeekButton, { size: "large", fullWidth: true, color: "primary", variant: "contained", onClick: handleSubmit }, intl.formatMessage(messages.createProspectButton))))))));
};
export default CreateProspectDialog;
